import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { Instant } from 'modules/graphql';
import { JOB_STATE as JOB_STATE_ENUM, JOB_TYPE } from './jobs';
import { EXPORT_DATA_TYPE } from './export';

export enum JOBS_TABLE_COLUMNS {
  JOB_ID = 'id',
  JOB_NAME = 'jobName',
  JOB_TYPE_NAME = 'jobTypeName',
  JOB_STATE = 'jobState',
  ORG_ID = 'organizationId',
  PROJECT_ID = 'projectId',
  RECURRING = 'recurringJobId',
  SCHEDULED_START_TIME = 'scheduledStartTime',
  END_TIME = 'endTime',
}

export type JOBS_TABLE_COLUMN_DATA = {
  id: JOBS_TABLE_COLUMNS;
  label: string;
  isSortable: boolean;
  initialSortDirection: SORT_DIRECTIONS;
  isRightAligned: boolean;
};

export type TableInfo = {
  count: number;
  limit: number;
  offset: number;
  page: number;
};

type TestJobData = {
  state: string;
  testValue: string;
};

type ExportJobData = {
  dataType: EXPORT_DATA_TYPE;
  delimiter: string;
  projectId: number;
  omitFields: string[];
  onlyFields: string[];
  outputFormat: string;
  inProgressState: {
    subfolder: string;
    errorCount: number;
    lastScrollId: string;
    exportTruncated: boolean;
    numBytesWritten: number;
  };
};

export type CommonTableRowItems = {
  [JOBS_TABLE_COLUMNS.JOB_ID]: number;
  [JOBS_TABLE_COLUMNS.RECURRING]?: number;
  createdAt: Instant;
  attempts: number;
  [JOBS_TABLE_COLUMNS.SCHEDULED_START_TIME]: Instant;
  [JOBS_TABLE_COLUMNS.END_TIME]: Instant;
  [JOBS_TABLE_COLUMNS.JOB_STATE]: JOB_STATE_ENUM;
  [JOBS_TABLE_COLUMNS.ORG_ID]: number;
  [JOBS_TABLE_COLUMNS.PROJECT_ID]: number;
};

export type ExportTableRow = CommonTableRowItems & {
  [JOBS_TABLE_COLUMNS.JOB_TYPE_NAME]: JOB_TYPE.EXPORT_JOB;
  jobData: ExportJobData;
};

export type TestTableRow = CommonTableRowItems & {
  [JOBS_TABLE_COLUMNS.JOB_TYPE_NAME]: JOB_TYPE.TEST_JOB;
  jobData: TestJobData;
};

export type TableRow = ExportTableRow | TestTableRow;

export type JobTableData = {
  info?: TableInfo;
  results?: TableRow[];
};

export type JobTableDataState = {
  items: TableRow[];
  loading: boolean;
  error: boolean;
};

export type JobTableFilterState = {
  jobStates: string[];
  jobTypeNames: string[];
};

export type JobTableSortState = {
  sortBy: JOBS_TABLE_COLUMNS;
  sortDirection: SORT_DIRECTIONS;
};

export type JobTablePaginationState = {
  page: number;
  pageSize: number;
  count: number;
};

export enum TABLE_FILTER {
  JOB_STATES = 'jobStates',
  JOB_TYPE_NAMES = 'jobTypeNames',
}

export type JobTableQuery = {
  filterInfo: JobTableFilterState;
  pagination: {
    limit: number;
    offset: number;
  };
  sort: JobTableSortState;
};
